import api from "../api";
import {ElMessage} from "element-plus";

export default {
    namespaced: true,
    state: {
        modules: {data: [], current_page: 1, total: 0, per_page: 10},
        errors: {
            data: {
                errors: {
                    charge_type_id: [],
                    amount: [],
                    effective_date: [],
                    project_id: []
                }
            }
        },
        has_errors: false,
        loading: false,
        dialogVisible: false,
    },
    getters: {
        dialogVisible: state => state.dialogVisible,
        modules: state => state.modules,
        errors: state => state.errors,
        has_errors: state => state.has_errors,
        loading: state => state.loading,
        payments: state => state.payments
    },
    mutations: {
        setLoading(state, status) {
            state.loading = status
        },
        setDialogVisible(state, status) {
            state.dialogVisible = status;
        },
        setModules(state, data) {
            state.modules = data;
        },
        setModulePayments(state, data) {
            state.payments = data;
        },
        setErrors(state, errors) {
            state.errors = errors
        },
        hasErrors(state, val) {
            state.has_errors = val
            if (!val) {
                state.errors = {
                    data: {
                        errors: {
                            charge_type_id: [],
                            amount: [],
                            effective_date: [],
                            project_id: []
                        }
                    }
                };
            }
        }
    },
    actions: {
        openDialogVisible({commit}, status) {
            commit('setDialogVisible', status);
        },

        async getModules({commit}, filters) {
            try {
                commit('activateLoading', 'user/list', {root: true});
                const response = await api.getModules(filters);
                commit('setModules', response);
                commit('deactivateLoading', 'county/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },
    }
}
